// @ts-nocheck
import styled from "styled-components";

export const StyledCol = styled.col<{ width: number }>`
    width: ${({ width }) => width}%;
`;
